<template>
  <div>
    <input class="e-input" type="text" v-model='searchNum' @keydown.enter='keydown' style="width: 200px;margin:0px 5px 5px 0px">
    <button :title='$t("MCS.superSearch")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='getGridData' data-ripple="true" tabindex="-1">
    </button>
    <div class="h100vh-500">
    <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field="userNum" :visible="false"></e-column>
        <e-column field='userNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userNum")' width='150' textAlign='Center'></e-column>
        <e-column field='userAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
        <e-column field='userType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
        <e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='registerStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>
        <!--<e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='videoRegisterStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>-->
        <!--<e-column field='registerStatus' clipMode='EllipsisWithTooltip' :valueAccessor='dataRegisterStatusFormatter' :headerText='$t("MCS.registerStatus")' width='150' textAlign='Center'></e-column>-->
        <e-column field='stunStatus' clipMode='EllipsisWithTooltip' :valueAccessor='stunStatusFormatter' :headerText='$t("MCS.stunKillStatus")' width='150' textAlign='Center'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getGridData(info)' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
  </div>
</template>

<script>
import commonJS from '../../common';

export default {
  name: 'UserTableLayer',
  mixins: [commonJS],
  data() {
    return {
      data: {},
      info: '',
      userNumSearch: '',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      searchNum: '',
      userType: 0
    };
  },
  methods: {
    keydown(event){
      event.stopPropagation();//禁用回车事件
    },
    getGridData(ne = null, userType = 0) {
      const $this = this;
      if ($this.userType === 0) {
        $this.userType = userType;
      }
      let vo;
      if (ne.msgid !== undefined) {
        $this.info = ne;
      }
      vo = {
        flag: 2,
        userNum: $this.searchNum,
        userType: $this.userType,
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        vpnId: 0,
        vpnClass: 0,
      };
      const params = {
        info: $this.info,
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data;
        const resData = res.resultVal.result;
        $this.data = resData;
        $this.page.totalCount = res.resultVal.totalCnt;
      });
    },

    getClickData() {
      return this.$refs.grid.getSelectedRecords()[0];
    }
  },
};
</script>

<style scoped>
  .my-class.e-btn:active,.my-class.e-btn:focus{
    box-shadow: none !important;
  }

  .my-class{
    width: 30px;
    height: 30px;
    padding: 0px;
    color: #007bff;
    background-color: #FFFFFF;
    border: 0px;
  }
</style>
